/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsUserRole
 */
export interface MelcoModelsUserRole {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserRole
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserRole
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserRole
     */
    name?: string | null;
}

export function MelcoModelsUserRoleFromJSON(json: any): MelcoModelsUserRole {
    return MelcoModelsUserRoleFromJSONTyped(json, false);
}

export function MelcoModelsUserRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUserRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function MelcoModelsUserRoleToJSON(value?: MelcoModelsUserRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
    };
}


